'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamor = require('glamor');

exports.default = (0, _glamor.css)({
  overflow: 'hidden',
  position: 'absolute',
  height: '1px',
  width: '1px',
  padding: 0,
  margin: '-1px',
  border: 0,
  clip: 'rect(0 0 0 0)'
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3V0aWxzL29mZnNjcmVlbkNzcy5qcyJdLCJuYW1lcyI6WyJvdmVyZmxvdyIsInBvc2l0aW9uIiwiaGVpZ2h0Iiwid2lkdGgiLCJwYWRkaW5nIiwibWFyZ2luIiwiYm9yZGVyIiwiY2xpcCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O2tCQUVlLGlCQUFJO0FBQ2pCQSxZQUFVLFFBRE87QUFFakJDLFlBQVUsVUFGTztBQUdqQkMsVUFBUSxLQUhTO0FBSWpCQyxTQUFPLEtBSlU7QUFLakJDLFdBQVMsQ0FMUTtBQU1qQkMsVUFBUSxNQU5TO0FBT2pCQyxVQUFRLENBUFM7QUFRakJDLFFBQU07QUFSVyxDQUFKLEMiLCJmaWxlIjoib2Zmc2NyZWVuQ3NzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtjc3N9IGZyb20gJ2dsYW1vcidcblxuZXhwb3J0IGRlZmF1bHQgY3NzKHtcbiAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgaGVpZ2h0OiAnMXB4JyxcbiAgd2lkdGg6ICcxcHgnLFxuICBwYWRkaW5nOiAwLFxuICBtYXJnaW46ICctMXB4JyxcbiAgYm9yZGVyOiAwLFxuICBjbGlwOiAncmVjdCgwIDAgMCAwKSdcbn0pXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/utils/offscreenCss.js
// module id = 593
// module chunks = 0